<template>
  <view
    class="custom-popup"
    :class="customData.showMask && 'mask'"
    v-show="customData.showCustomPopup"
  >
    <view class="custom-popup-body">
      <view class="custom-popup-header flex-align mb-20">
        <view
          class="iconfont text-18 lead-1"
          :class="typeIcon"
          :style="{ color: typeColor }"
        ></view>
        <view class="text-16 ml-10">{{ customData.title }}</view>
      </view>
      <view class="custom-popup-main" style="color: #74758a">
        {{ customData.content }}
      </view>
      <view class="custom-popup-footer flex-align flex-reverse gap-20 mt-20">
        <view
          v-if="customData.showConfirm"
          class="confirm-btn"
          :style="{ backgroundColor: typeColor }"
          @click="customData.confirmFun"
        >
          {{ customData.confirmText }}
        </view>
        <view
          v-if="customData.showCancel"
          class="cancel-btn"
          @click="customData.cancelFun"
        >
          {{ customData.cancelText }}
        </view>
      </view>
    </view>
  </view>
</template>

<script>
import { customData } from "./use/customPopup";

export default {
  data() {
    return { customData };
  },
  computed: {
    typeColor() {
      const obj = {
        tips: "#4d6bfe",
        error: "#EB2F2F",
        warning: "#FD8333",
        success: "#2EA043",
      };
      return obj[this.customData.type];
    },
    typeIcon() {
      const obj = {
        tips: "icon-warning",
        error: "icon-error",
        warning: "icon-warning",
        success: "icon-success",
      };
      return obj[this.customData.type];
    },
  },
  deactivated() {
    this.customData.cancelFun();
  },
  beforeUnmount() {
    this.customData.cancelFun();
  },
};
</script>

<style lang="scss" scpoed>
.custom-popup {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 999999;

  &.mask {
    background-color: #00000075;
  }

  .custom-popup-body {
    position: absolute;
    width: 450px;
    max-width: calc(100vw - 20px) !important;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 0 10px 10px #00000010;
    @mixin btn {
      border-radius: 100px;
      padding: 0 16px;
      height: 30px;
      display: flex;
      align-items: center;
      line-height: 1;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }

    .confirm-btn {
      @include btn;
      color: #fff;
    }

    .cancel-btn {
      @include btn;
      border: 1px solid #e8eaf2;
    }
  }
}

.custom-popup-main {
  margin-bottom: 20px;
  margin-top: 20px;
}
</style>
